module.exports = __webpack_public_path__ + "img/sad.ba53c0f5.svg";